import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@resiliatech/birdsong'

export const ActionButton = styled(Button)({
  minWidth: '60px',
})

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: '100%',
})

export const SectionTitle = styled('div')({
  fontSize: '18px',
  fontWeight: 500,
  marginBottom: '16px',
})

export const SelectContainer = styled(FormControl)({
  width: '100%',
})

export const ActionContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  marginTop: '32px',
})

export const StyledInputLabel = styled(InputLabel)({
  borderRadius: '4px',
})

export const StyledSelect = styled(Select)<SelectProps<string>>({
  backgroundColor: colors.background.secondaryBackground,
  height: '42px',
})

export const MenuItemWithPadding = styled(MenuItem)({
  paddingTop: '12px',
  paddingBottom: '12px',
})
